var _defs, _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnaquelLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 330.9022,
    height: 484.5842,
    viewBox: "0 0 330.9022 484.5842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111111;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "anaquel_logo_v2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.1358,
    y: 30.9217,
    width: 202.6866,
    height: 63.175
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.1358,
    y: 194.1239,
    width: 202.6866,
    height: 63.175
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.7272,484.5842h63.175V0h-63.175V21.0068l-.0241.0388a42.1491,42.1491,0,0,1,41.9437,42.1486h0a42.1491,42.1491,0,0,1-42.149,42.149h.2294v78.6635l-.0241.0388a42.1491,42.1491,0,0,1,41.9437,42.1486h0a42.1491,42.1491,0,0,1-42.149,42.149h.2294Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.167,484.5842H0V0H64.167V21.0068l.0244.0388c-23.5621.1131-42.6022,18.95-42.6022,42.1486h0c0,23.2782,19.167,42.149,42.8108,42.149h-.233v78.6635l.0244.0388c-23.5621.1131-42.6022,18.9505-42.6022,42.1486h0c0,23.2782,19.167,42.149,42.8108,42.149h-.233Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaquelLogoBlack);
export default __webpack_public_path__ + "static/media/anaquel_logo_black.21956fd1ec5db609c1858d4004e1e319.svg";
export { ForwardRef as ReactComponent };